export const DT_DESCRIPTION_LIST_DIRECTION = ['row', 'column'];
